import Compressorjs from 'compressorjs';
import utils from '../libs/utils';
import fileService from './file-service';

export default {

  // 压缩图片
  compressImage(file, options) {
    return new Promise((resolve, reject) => {
      const defaultOptions = {
        maxWidth: 3000,
        maxHeight: 3000,
        quality: 0.9,
        error() {
          utils.msgbox.alert({
            content: '图片处理失败',
          });
          reject();
        },
      };
      const useOptions = options || defaultOptions;
      const onSuccess = (result) => {
        resolve(result);
      };
      useOptions.success = onSuccess;

      // eslint-disable-next-line no-new
      new Compressorjs(file, useOptions);
    });
  },
  // 是否是图片文件
  isImage(data, type = 'url') {
    if (!data) return false;
    if (type === 'url') {
      const suffix = fileService.getFileNameAndSuffixByUrl(data).suffix;
      if (!suffix) return false;
      return ['jpeg', 'png', 'jpg'].indexOf(suffix) > -1;
    } else if (type === 'suffix') {
      return ['jpeg', 'png', 'jpg'].indexOf(data) > -1;
    } else if (type === 'mine') {
      return ['image/jpeg', 'image/png', 'image/jpg'].indexOf(data) > -1;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/services/image-service.js